import {
  setTaxes,
  setTaxesSelection,
  setTaxJurisdictionSelection,
  setTaxCategories,
  setTaxCategorySelection,
  setProductTaxClassifications,
  setProductTaxClassificationSelection,
} from "../slice/taxSlice";
import { apiSlice } from "./apiSlice";

export const taxApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    createTax: builder.mutation({
      invalidatesTags: ["TaxRate"],
      query: data => ({ url: "/api_tax/tax_rate/", method: "post", body: data }),
    }),
    getTax: builder.query({
      providesTags: ["TaxRate"],
      query: params => (params ? `/api_tax/tax_rate/?${params}` : "/api_tax/tax_rate/"),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setTaxes(result.data))).catch(error => {});
      },
    }),
    getTaxById: builder.query({
      providesTags: ["TaxRate"],
      query: id => ({
        url: `/api_tax/tax_rate/${id}/`,
      }),
    }),
    getTaxSelection: builder.query({
      providesTags: ["TaxRate"],
      query: () => "/api_tax/tax_rate/selection/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setTaxesSelection(result.data))).catch(error => {});
      },
    }),
    getTaxJurisdictionSelection: builder.query({
      query: () => "/api_tax/tax_jurisdiction/selection/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setTaxJurisdictionSelection(result.data)))
          .catch(error => {});
      },
    }),
    updateTax: builder.mutation({
      invalidatesTags: ["TaxRate"],
      query: ({ data, id }) => ({
        url: `/api_tax/tax_rate/${id}/`,
        method: "PUT",
        body: data,
      }),
    }),

    // Tax Categories
    getTaxCategory: builder.query({
      query: params =>
        params ? `/api/tax/v1/tax_category/?${params}` : "/api/tax/v1/tax_category/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setTaxCategories(result.data))).catch(error => {});
      },
    }),
    getTaxCategorySelection: builder.query({
      query: params =>
        params
          ? `/api/tax/v1/tax_category/selection/?${params}`
          : "/api/tax/v1/tax_category/selection/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setTaxCategorySelection(result.data)))
          .catch(error => {});
      },
    }),
    createTaxCategory: builder.mutation({
      query: data => ({ url: "/api/tax/v1/tax_category/", method: "POST", body: data }),
    }),
    getTaxCategoryById: builder.query({
      query: id => ({
        url: `/api/tax/v1/tax_category/${id}/`,
      }),
    }),
    updateTaxCategory: builder.mutation({
      query: ({ data, id }) => ({
        url: `/api/tax/v1/tax_category/${id}/`,
        method: "PATCH",
        body: data,
      }),
    }),

    // Product Tax Classification Mappings
    getProductTaxClassificationMapping: builder.query({
      query: params =>
        params
          ? `/api/tax/v1/product_tax_classification_mapping/?${params}`
          : "/api/tax/v1/product_tax_classification_mapping/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setProductTaxClassifications(result.data)))
          .catch(error => {});
      },
    }),
    getProductTaxClassificationMappingById: builder.query({
      query: id => ({
        url: `/api/tax/v1/product_tax_classification_mapping/${id}/`,
      }),
    }),
    createProductTaxClassificationMapping: builder.mutation({
      query: data => ({
        url: "/api/tax/v1/product_tax_classification_mapping/",
        method: "POST",
        body: data,
      }),
    }),
    updateProductTaxClassificationMapping: builder.mutation({
      query: ({ data, id }) => ({
        url: `/api/tax/v1/product_tax_classification_mapping/${id}/`,
        method: "PATCH",
        body: data,
      }),
    }),

    // Selections
    getProductTaxClassificationSelection: builder.query({
      query: () => "/api/tax/v1/product_tax_classification/selection/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setProductTaxClassificationSelection(result.data)))
          .catch(error => {});
      },
    }),
    getProductTaxClassification: builder.query({
      query: params =>
        params
          ? `/api/tax/v1/product_tax_classification/?${params}`
          : "/api/tax/v1/product_tax_classification/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setProductTaxClassifications(result.data)))
          .catch(error => {});
      },
    }),
    getProductTaxClassificationById: builder.query({
      query: id => `/api/tax/v1/product_tax_classification/${id}/`,
    }),
    createProductTaxClassification: builder.mutation({
      query: data => ({
        url: "/api/tax/v1/product_tax_classification/",
        method: "POST",
        body: data,
      }),
    }),
    updateProductTaxClassification: builder.mutation({
      query: ({ data, id }) => ({
        url: `/api/tax/v1/product_tax_classification/${id}/`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  useCreateTaxMutation,
  useGetTaxQuery,
  useLazyGetTaxSelectionQuery,
  useGetTaxSelectionQuery,
  useGetTaxJurisdictionSelectionQuery,
  useLazyGetTaxJurisdictionSelectionQuery,
  useGetTaxByIdQuery,
  useUpdateTaxMutation,
  useGetTaxCategoryQuery,
  useGetTaxCategorySelectionQuery,
  useLazyGetTaxCategorySelectionQuery,
  useCreateTaxCategoryMutation,
  useGetTaxCategoryByIdQuery,
  useUpdateTaxCategoryMutation,
  useGetProductTaxClassificationMappingQuery,
  useGetProductTaxClassificationMappingByIdQuery,
  useCreateProductTaxClassificationMappingMutation,
  useUpdateProductTaxClassificationMappingMutation,
  useGetProductTaxClassificationSelectionQuery,
  useLazyGetProductTaxClassificationSelectionQuery,
  useGetProductTaxClassificationQuery,
  useGetProductTaxClassificationByIdQuery,
  useCreateProductTaxClassificationMutation,
  useUpdateProductTaxClassificationMutation,
} = taxApiSlice;
